import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Divider } from '@redlink/components/atoms';

export const BodyBlockContainer = memo(({ children }) => {
  const { styles } = useStyle();

  return (
    <View style={styles.container}>
      {children[0]}
      <Divider horizontal={false} margin={16} />
      {children[1]}
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flex: 1,
    flexDirection: 'row',
  },
}));
